import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import Login from "views/Auth/Login/Login";
import Register from "views/Auth/Register/Register";
import { clearAuthSession } from "utils/authSession";

const Pages = (props) => {
  const [activeColor, setActiveColor] = React.useState(() => {
    const saved = localStorage.getItem("sidebarColor");
    return saved || "tertiary";
  });
  
  const [isLoading, setIsLoading] = React.useState(true);
  const [sessionValid, setSessionValid] = React.useState(false);
  const token = localStorage.getItem("token");
  const queryClient = useQueryClient();

  useEffect(() => {
    if (token) {
      import("../../api/restClient").then(({ default: restClient }) => {
        restClient.get('account', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
          .then(response => {
            if (response.data.session_expired === true) {
              clearAuthSession(queryClient);
              setSessionValid(false);
              setIsLoading(false);
              return;
            }
            if (response.data?.jwt) {
              localStorage.setItem('token', response.data.jwt);
            }
            setSessionValid(true);
            setIsLoading(false);
          })
          .catch(() => {
            // Account doğrulanamadıysa (401/403/500/network) token ile içeri alma.
            clearAuthSession(queryClient);
            setSessionValid(false);
            setIsLoading(false);
          });
      });
    } else {
      setIsLoading(false);
      setSessionValid(false);
    }
  }, [token, queryClient]);

  if (isLoading) {
    return null;
  }
  
  if (token && sessionValid) {
    return <Navigate to="/dashboard" replace />;
  }

  // Check current path to determine which component to render
  const currentPath = window.location.pathname;
  
  if (currentPath === "/login") {
    return <Login activeColor={activeColor} />;
  } else if (currentPath === "/register") {
    return <Register activeColor={activeColor} />;
  } else {
    return <Navigate to="/" replace />;
  }
};

export default Pages;
